import { createContext, useContext, type ReactNode } from 'react'

type Shell = {
  /** The controls the shell keeps at the right of every top bar, such as Help and the account. */
  topBarTrailing: ReactNode
}

// Null outside the app shell's frame, where page headers draw their classic bar.
export const ShellContext = createContext<Shell | null>(null)

export const useShell = () => useContext(ShellContext)
